<template>
    <div class="fab-container">
        <b-button variant="success" class="fab-main" @click="openWhatsAppChat">
            <i class="fa fa-whatsapp" style="font-size: 40px;" aria-hidden="true"></i>
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'floating-button',
    props: {
        phoneNumber: { type: String, default: "" }
    },
    methods: {
        openWhatsAppChat() {
            const formattedNumber = this.phoneNumber.replace(/^\+/, '');
            window.open(`https://wa.me/${formattedNumber}`, '_blank');
        }
    }
};
</script>

<style scoped>
  .fab-container {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 1000;
    }

    .fab-main {
        width: max-content;
        height: 60px;
        font-size: 18px;
        font-weight: bold;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        transition: transform 0.2s;
    }

    .fab-main:hover {
        transform: scale(1.1);
    }
</style>
